"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selected = exports.Deselected = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const colors_1 = require("../colors");
/* eslint-disable react/jsx-curly-brace-presence */
class Deselected extends react_1.PureComponent {
    render() {
        const _a = this.props, { width, color, backgroundColor } = _a, rest = __rest(_a, ["width", "color", "backgroundColor"]);
        return (react_1.default.createElement("svg", Object.assign({ width: width, height: width, viewBox: "0 0 24 24" }, rest),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("path", { id: "radio-default-a", d: `M12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,
            2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,
            21.8181818 Z M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z` })),
            react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
                react_1.default.createElement("circle", { cx: "12", cy: "12", r: "12", stroke: "black", strokeWidth: "0", fill: backgroundColor }),
                react_1.default.createElement("use", { fill: color, xlinkHref: "#radio-default-a" }))));
    }
}
exports.Deselected = Deselected;
Deselected.propTypes = {
    width: prop_types_1.default.string,
    color: prop_types_1.default.string,
    backgroundColor: prop_types_1.default.string,
};
Deselected.defaultProps = {
    width: '16px',
    color: colors_1.cobalt.base,
    backgroundColor: 'none',
};
class Selected extends react_1.PureComponent {
    render() {
        const _a = this.props, { width, color, backgroundColor } = _a, rest = __rest(_a, ["width", "color", "backgroundColor"]);
        return (react_1.default.createElement("svg", Object.assign({ width: width, height: width, viewBox: "0 0 24 24" }, rest),
            react_1.default.createElement("defs", null,
                react_1.default.createElement("path", { id: "selected-a", d: `M21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,
            12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 Z M0,
            12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z M12,
            17.4545455 C15.0124623,17.4545455 17.4545455,15.0124623 17.4545455,12 C17.4545455,8.98753773 15.0124623,6.54545455 12,6.54545455 C8.98753773,
            6.54545455 6.54545455,8.98753773 6.54545455,12 C6.54545455,15.0124623 8.98753773,17.4545455 12,17.4545455 Z` })),
            react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
                react_1.default.createElement("circle", { cx: "12", cy: "12", r: "12", stroke: "black", strokeWidth: "0", fill: backgroundColor }),
                react_1.default.createElement("use", { fill: color, xlinkHref: "#selected-a" }))));
    }
}
exports.Selected = Selected;
Selected.propTypes = {
    width: prop_types_1.default.string,
    color: prop_types_1.default.string,
    backgroundColor: prop_types_1.default.string,
};
Selected.defaultProps = {
    width: '16px',
    color: colors_1.teal.base,
    backgroundColor: 'none',
};
